import { Grid } from "components/Grid/Grid";
import TabSelection from "components/TabSelection";
import Text from "components/Text";
import { ReactComponent as CurvedArrow } from "icons/CurvedArrow.svg";
import { LoaderContainer } from "pages/Job/JobPost/JobPurpose/JobPurpose.styled";
import { FC } from "react";
import { IconContext } from "react-icons";
import { BiLoaderAlt } from "react-icons/bi";
import theme from "theme";
import {
    DiscountLabel,
    DiscountSection,
    DurationWrapper,
    PricingContent,
    PricingHeader,
    PricingWrapper,
} from "./Pricing.styled";
import { PricingOption } from "./PricingOption/PricingOption";
import { usePricing } from "./usePricing";
import {useAppSelector} from "../../slice";

export const Pricing: FC = () => {
    const {
        duration,
        handleDurationChange,
        plans,
        isFetchingPlans,
        handleChoosePlan,
        planSelected,
        isLoadingCheckout,
        planId,
    } = usePricing();


    const { is_agency } = useAppSelector(
        (state) => state.user
    )

    const filteredPlans = plans.filter((plan: any) =>
        is_agency ? plan.type === "Agency" : plan.type === "User"
    );

    return (
        <PricingWrapper>
            {planId ? (
                <PricingContent>
                    <Text variant="heading4">
                        Redirecting to payment page...
                    </Text>
                </PricingContent>
            ) : (
                <>
                    <PricingHeader>
                        <Grid
                            column={true}
                            direction="column-direction"
                            rowGap={1}
                        >
                            <Text
                                variant="heading2"
                                fontWeight="800"
                                color={theme.colors.grey.dark}
                                fontSize="36px"
                            >
                                Simple & Transparent{" "}
                                <Text
                                    variant="heading2"
                                    color={theme.colors.purple.primary}
                                    fontWeight="800"
                                    fontSize="36px"
                                >
                                    Pricing Plans
                                </Text>
                            </Text>
                            {/* <Text
                                variant="label"
                                fontWeight="500"
                                color={theme.colors.grey.secondary}
                            >
                                Invest In Your Modeling Career
                            </Text> */}
                        </Grid>
                        <DurationWrapper>
                            <TabSelection
                                defaultActive="monthly"
                                options={[
                                    {
                                        label: "Monthly",
                                        value: "monthly",
                                    },
                                    {
                                        label: "Yearly",
                                        value: "yearly",
                                    },
                                ]}
                                onChange={handleDurationChange}
                            />
                            {duration === "yearly" && (
                                <DiscountSection>
                                    <CurvedArrow />
                                    <DiscountLabel>
                                        <Text variant="body1" fontSize="11px">
                                            30% Off
                                        </Text>
                                    </DiscountLabel>
                                </DiscountSection>
                            )}
                        </DurationWrapper>
                    </PricingHeader>
                    <PricingContent>
                        {isFetchingPlans && (
                            <IconContext.Provider
                                value={{ className: "loader" }}
                            >
                                <LoaderContainer>
                                    <BiLoaderAlt />
                                </LoaderContainer>
                            </IconContext.Provider>
                        )}
                        {filteredPlans.length > 0 &&
                            filteredPlans.map((plan: any) => {
                         const showMonthlyPrice = duration === 'monthly';
                          const intervalToShow = showMonthlyPrice ? 'month' : 'year';

        if (plan.interval === intervalToShow) {
        return (
            <PricingOption
                 key={plan.id}
                 name={plan.name} 
                 perMonthPrice={plan.monthlyPrice / 100}
                 perYearPrice={plan.yearlyPrice / 100}
                 handleChoosePlan={() => handleChoosePlan(plan.id)}
                 features={plan.benefits}
                 isLoading={isLoadingCheckout && planSelected === plan.id}
                 priceToShow={plan.interval === 'month' ? plan.monthlyPrice : plan.yearlyPrice}
                 intervalToShow={plan.interval} 
             />
        );
        }
    })}
         </PricingContent>
        </>
            )}
        </PricingWrapper>
    );
};
